import { useLocation } from 'react-router-dom'

import { Box, Hint, tokens } from '@factorialco/deprecated-design-system'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

type Props = {
  onClose: () => void
  open: boolean
  children: JSX.Element
}

const BecomeHint = ({ onClose, open, children }: Props) => {
  const { pathname } = useLocation()

  const closePopover = () => {
    onClose()
    track(trackingEvents.employee.become.closeBecomeHint, { from: pathname })
  }

  return (
    <Hint.Popover.Provider steps={1} onClose={closePopover} onFinish={closePopover}>
      {open && (
        <Box style={{ marginTop: tokens.dimensions.s4, marginRight: `-${tokens.dimensions.s4}` }}>
          <Hint.Popover
            step={1}
            actionLabel={i18n.t('employees.become.hint.cta_label')}
            description={i18n.t('employees.become.hint.description')}
            title={i18n.t('employees.become.hint.title')}
            position="left bottom"
          />
        </Box>
      )}
      {children}
    </Hint.Popover.Provider>
  )
}

export default BecomeHint
